import { render, staticRenderFns } from "./MemberPopDetail.vue?vue&type=template&id=20130314&"
import script from "./MemberPopDetail.vue?vue&type=script&lang=js&"
export * from "./MemberPopDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports